// Helper function to format full address from components
export const formatAddress = (employee) => {
  const addressParts = []

  if (employee.streetAddress) {
    addressParts.push(employee.streetAddress)
  }
  if (employee.city) {
    addressParts.push(employee.city)
  }
  if (employee.state) {
    addressParts.push(employee.state)
  }
  if (employee.postalCode) {
    addressParts.push(employee.postalCode)
  }

  return addressParts.length > 0 ? addressParts.join(', ') : null
}

// Helper function to format last active date
export const formatLastActive = (employee) => {
  // Helper to calculate days ago from a date
  const calculateDaysAgo = (dateValue) => {
    const date = new Date(dateValue)
    if (Number.isNaN(date.getTime())) {
      return null
    }

    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const activityDate = new Date(date)
    activityDate.setHours(0, 0, 0, 0)

    const diffDays = Math.floor((today - activityDate) / (1000 * 60 * 60 * 24))

    if (diffDays === 0) {
      return 'Today'
    }
    if (diffDays === 1) {
      return '1d ago'
    }
    return `${diffDays}d ago`
  }

  // Check if we have a pre-calculated lastActive
  if (employee.lastActive) {
    // If it's already a formatted string (like "2d ago", "Today", "Never"), return it
    if (typeof employee.lastActive === 'string') {
      // Check if it looks like a formatted string (contains "ago", "Today", or "Never")
      if (employee.lastActive.includes('ago') || employee.lastActive === 'Today' || employee.lastActive === 'Never') {
        return employee.lastActive
      }
      // Otherwise, try to parse it as a date
      const formatted = calculateDaysAgo(employee.lastActive)
      if (formatted) {
        return formatted
      }
      // If parsing fails, return the string as-is (might be a formatted string we don't recognize)
      return employee.lastActive
    }
    // If it's a Date object, format it
    if (employee.lastActive instanceof Date) {
      return calculateDaysAgo(employee.lastActive) || 'Never'
    }
  }

  // Check lastSignInDate
  if (employee.lastSignInDate) {
    const formatted = calculateDaysAgo(employee.lastSignInDate)
    if (formatted) {
      return formatted
    }
  }

  // No activity data available
  return 'Never'
}
